<template>
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :layout="layout"
            :total="total"
        >
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: 'pagination',
    components: {},
    props: {
        total: {
            type: Number,
            default: 1
        },
        pageNum: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 10
        },
        layout: {
            type: String,
            default: 'total, sizes, prev, pager, next, jumper'
        },
        pageSizes: {
            type: Array,
            default: function () {
                return [10, 20, 30, 50]
            }
        }
    },
    watch: {
        pageNum(newNum) {
            this.currentPage = newNum
        }
    },
    data() {
        return {
            currentPage: 1
        }
    },
    mounted() {
        console.log(this.$router)
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val
            this.$emit('handleCurrentChange', { pageNum: val })
        },
        handleSizeChange(val) {
            console.log(val)
            this.$emit('handleSizeChange', { pageSize: val })
        }
    }
}
</script>
<style lang="less" scoped>
.pagination {
    padding: 12px 24px;
    text-align: right;
    overflow: hidden;
}
::v-deep .el-input .el-input__inner {
    height: 28px;
    line-height: 28px;
}
</style>
